/*
  LK-AUDIT-FIXES (2026-10-13) — promo code feedback in the bag.
  Before: every code showed "saved — applied at checkout if valid", and the message vanished when the bag refreshed.
  Now: after the code is sent, the bag is checked. The shopper sees "applied" or "can't be used with the items in your bag",
  and the message stays visible after the refresh. If the check is not possible, the old "saved" message is shown.
  Runs before lymko-core.js's own promo handler and replaces it. TO REVERT: delete this file and its <script> tag in layout/theme.liquid.
*/
(() => {
  "use strict";
  const CFG = window.LYMKO || {};
  const TX = CFG.t || {};
  const T = (k, d, o) => String(TX[k] || d).replace(/\[(\w+)\]/g, (m, x) => o && x in o ? o[x] : m);
  const R = CFG.routes || { root: "/" };
  const U = (p) => (R.root.endsWith("/") ? R.root : R.root + "/") + p;
  function sectionsParam() {
    const s = ["cart-drawer"];
    const c = document.querySelector("[data-cart-page]");
    const sec = c && c.closest(".shopify-section");
    if (sec) s.push(sec.id.replace("shopify-section-", ""));
    return s.join(",");
  }
  async function refreshSections() {
    try {
      const res = await fetch(`${location.pathname}?sections=${sectionsParam()}`);
      if (!res.ok) return;
      const data = await res.json();
      Object.entries(data).forEach(([id, html]) => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, "text/html");
        if (id === "cart-drawer") {
          const n = document.querySelector("#dcart"), f = doc.querySelector("#dcart");
          if (n && f) n.innerHTML = f.innerHTML;
        } else {
          const n = document.getElementById("shopify-section-" + id), f = doc.getElementById("shopify-section-" + id);
          if (n && f) n.innerHTML = f.innerHTML;
        }
      });
      if (window.Lymko) {
        if (window.Lymko.reveal) window.Lymko.reveal();
        if (window.Lymko.markFavs) window.Lymko.markFavs();
      }
    } catch (e) {
    }
  }
  function msgFor(form) {
    if (!form) return null;
    const input = form.querySelector("input[name=discount]") || (form.id && document.querySelector(`input[form="${form.id}"]`));
    if (form.nextElementSibling && form.nextElementSibling.classList.contains("pmsg")) return form.nextElementSibling;
    const p = input && input.closest(".promo");
    return p && p.nextElementSibling;
  }
  function show(form, cls, text) {
    const m = msgFor(form);
    if (m) {
      m.className = cls;
      m.textContent = text;
    }
  }
  window.addEventListener("submit", async (e) => {
    const f = e.target && e.target.closest && e.target.closest("[data-promo]");
    if (!f) return;
    e.preventDefault();
    e.stopPropagation();
    const inDrawer = !!f.closest("#dcart");
    const fid = f.id;
    const input = f.querySelector("input[name=discount]") || (fid && document.querySelector(`input[form="${fid}"]`));
    const code = (input && input.value || "").trim();
    if (!code) {
      show(f, "pmsg err", T("promo_empty", "Please enter a promo code."));
      return;
    }
    try {
      await fetch(U(`discount/${encodeURIComponent(code)}`), { credentials: "same-origin" });
    } catch (err) {
    }
    let state = "unknown";
    try {
      const c = await (await fetch(U("cart.js"), { headers: { Accept: "application/json" } })).json();
      const found = (c.discount_codes || []).find((d) => String(d.code).toLowerCase() === code.toLowerCase());
      if (found) state = found.applicable ? "ok" : "bad";
    } catch (err) {
    }
    const o = { code: code.toUpperCase() };
    let cls = "pmsg", text = T("promo_saved", "“[code]” saved — it’s applied at checkout if it’s valid for your bag.", o);
    if (state === "ok") text = T("promo_ok", "“[code]” applied to your bag.", o);
    if (state === "bad") {
      cls = "pmsg err";
      text = T("promo_bad", "“[code]” can’t be used with the items in your bag.", o);
    }
    show(f, cls, text);
    await refreshSections();
    const nf = (fid && document.getElementById(fid)) || (inDrawer && document.querySelector("#dcart [data-promo]")) || f;
    show(nf, cls, text);
  }, true);
})();